"use client";
import React from "react";
import { Loader2 } from "lucide-react";

interface CodeGenerationLoaderProps {
  isVisible: boolean;
}

export const CodeGenerationLoader: React.FC<CodeGenerationLoaderProps> = ({
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        backdropFilter: "blur(8px)",
        pointerEvents: "auto",
      }}
    >
      <div
        className="flex flex-col items-center justify-center gap-6 rounded-xl px-10 py-8 min-w-[280px]"
        style={{
          backgroundColor: "var(--surface)",
          border: "1px solid var(--border)",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
      >
        <Loader2
          className="animate-spin"
          size={56}
          style={{ color: "var(--primary)" }}
          strokeWidth={2.5}
        />
        <p
          className="text-xl font-semibold text-center"
          style={{ color: "var(--primary-text)" }}
        >
          Your code is being generated
        </p>
      </div>
    </div>
  );
};

